export const CRMCreditNote = [
  {
    "credit_note_number": "CN-0540",
    "credit_note_date": "22/03/2025",
    "customer": "Tirumala Home Foods",
    "status": "Open",
    "project": "suvarna",
    "reference_number": "9873",
    "amount": "Rs.5,500.00",
    "remaining_amount": "Rs.5,500.00"
  },
  {
    "credit_note_number": "CN-0539",
    "credit_note_date": "02/10/2024",
    "customer": "Tomatoes Super Market (Sai Manikanta)",
    "status": "Open",
    "project": "lakshmi",
    "reference_number": "9375353",
    "amount": "Rs.6,000.00",
    "remaining_amount": "Rs.6,000.00"
  },
  {
    "credit_note_number": "CN-0538",
    "credit_note_date": "17/09/2024",
    "customer": "AR Suguna Chicken",
    "status": "Open",
    "project": "priya info",
    "reference_number": "7367393",
    "amount": "Rs.11,854.00",
    "remaining_amount": "Rs.11,854.00"
  },
  {
    "credit_note_number": "CN-0536",
    "credit_note_date": "20/03/2024",
    "customer": "Tirumala Home Foods",
    "status": "Open",
    "project": "vamsi layouts",
    "reference_number": "723673",
    "amount": "Rs.5,000.00",
    "remaining_amount": "Rs.5,000.00"
  },
  {
    "credit_note_number": "CN-0535",
    "credit_note_date": "30/12/2023",
    "customer": "NG Supermarket",
    "status": "Open",
    "project": "satwic",
    "reference_number": "98832",
    "amount": "Rs.2,250.00",
    "remaining_amount": "Rs.2,250.00"
  },
  {
    "credit_note_number": "CN-0534",
    "credit_note_date": "28/11/2023",
    "customer": "Vinayaka Hospital",
    "status": "Open",
    "project": "gowthami",
    "reference_number": "8663",
    "amount": "Rs.2,500.00",
    "remaining_amount": "Rs.2,500.00"
  },

]
